/*
 * (c) Copyright Reserved EVRYTHNG Limited 2021. All rights reserved.
 * Use of this material is subject to license.
 * Copying and unauthorised use of this material strictly prohibited.
 */

import Cookies from '../_snowpack/pkg/js-cookie.js';
import psl from '../_snowpack/pkg/psl.js';

export const YEAR_IN_DAYS = 365;
export const ROOT_DOMAIN = psl.parse(window.location.host).domain;
/**
 * @param {string} key
 * @returns {any}
 */
export function getCookie(key) {
  const cookie = Cookies.get(key);
  try {
    return JSON.parse(cookie);
  } catch {
    return cookie;
  }
}

/**
 * @param {string} key
 * @param {any} value
 * @returns {any}
 */
export function setCookie(key, value) {
  Cookies.set(key, value, { expires: YEAR_IN_DAYS, domain: `.${ROOT_DOMAIN}` });
  return value;
}

/**
 * @param {string} key
 */
export function removeCookie(key) {
  Cookies.remove(key, { domain: `.${ROOT_DOMAIN}` });
}
